const VERSION_PLACEHOLDER = '{version}';
const SDK_URL = `https://www.saola.ai/sdk/saola.${VERSION_PLACEHOLDER}.js`;

const win = (window as any);

export const init = (accountToken: string, version: string = 'latest', customOptions: any = {}) => {
    setParams(accountToken, customOptions);
    injectSDK(version);
}

export const stop = () => {
    if (!win.Soala || !win.Soala.stop) return;
    win.Soala.stop();
}

export const customEvent = (eventType: string, data: string) => {
    if (!win.Soala || !win.Saola.customEvent) return;
    win.Soala.customEvent(eventType, data);
}

const setParams = (accountToken: string, customOptions: any = {}) => {
    win.SaolaParams = { token: accountToken, options: customOptions };
}

const injectSDK = (version: string) => {
    const SDKScript = win.document.createElement('script');
    SDKScript.defer = true;
    SDKScript.src = SDK_URL.replace(VERSION_PLACEHOLDER, version);
    win.document.head.appendChild(SDKScript);
}
